// extracted by mini-css-extract-plugin
module.exports = {"block":"statusColor_block__wjvMO","status":"statusColor_status__1v2M-","center":"statusColor_center__1RjWm"};